import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import Analytics from "@/Analytics";
import Verify from "@/Verify";
import Services from "@/Services";
import ServicePage from "@/ServicePage";
import serviceData from "@/serviceData";

const SERVICE_ROUTES = [
  'video-calls', 'phone-calls', 'sexting', 'custom-content', 'content',
  'girlfriend-experience', 'dick-ratings', 'worn-items'
];

const getComponent = () => {
  const path = window.location.pathname.replace(/\/$/, '') || '/';

  if (path === '/analytics') return <Analytics />;
  if (path === '/verify') return <Verify />;
  if (path === '/services') return <Services />;

  const slug = path.slice(1);
  if (SERVICE_ROUTES.includes(slug) && serviceData[slug]) {
    const data = serviceData[slug];
    return <ServicePage {...data} />;
  }

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {getComponent()}
  </React.StrictMode>,
);
